import { render, staticRenderFns } from "./MyUpdates.vue?vue&type=template&id=13aa8594&scoped=true"
import script from "./MyUpdates.vue?vue&type=script&lang=js"
export * from "./MyUpdates.vue?vue&type=script&lang=js"
import style0 from "./MyUpdates.vue?vue&type=style&index=0&id=13aa8594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13aa8594",
  null
  
)

export default component.exports